import React from "react";
import PropTypes from "prop-types";
import { fromJS } from "immutable";
import DropDown from "MODULES/shared/components/DropDown";
import { Config } from "MODULES/inventories/components/Detail/Header/DropdownActions";
import Action from "./Detail/Header/DropdownActions/Action";

export default function Controls({ inventory }) {
  const config = {
    applyLotCost: Config.applyLotCost,
    reserveForSale: Config.reserveForSale,
    reserveForRepair: Config.reserveForRepair,
    transfer: { ...Config.transfer },
    cancelTransfer: { ...Config.cancelTransfer },
    cancelModTo: { ...Config.cancelModTo },
    deleteInventory: Config.deleteInventory
  };

  const rows = Object.keys(config).map(key => (
    <Action
      inventory={fromJS(inventory)}
      config={config[key]}
      key={`full-view-${inventory.id}-${key}`}
    />
  ));

  return (
    <div>
      <DropDown icon="fa fa-fw fa-ellipsis-v" menuClass="dropdown-menu-right">
        {rows}
      </DropDown>
    </div>
  );
}

Controls.propTypes = {
  inventory: PropTypes.shape({
    reserve_for_seller_id: PropTypes.number,
    store_location: PropTypes.string
  }).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Controls.jsx